import { FunctionComponent, useContext } from 'react';
import { Typography } from '@mui/material';
import { AppContext } from '../../providers/AppContext';
import useWindowDimensions from '../../hooks/dimension';

interface GitHubTrophyProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const GitHubTrophy: FunctionComponent<GitHubTrophyProps> = (props: GitHubTrophyProps) => {

    const app = useContext(AppContext);
    const { height, width } = useWindowDimensions();


    return (
        <div
            id={props.id}
            draggable={true}
            onDragStart={props.handleDrag}
            onDragOver={(e: any) => e.preventDefault()}
            onDrop={(e) => props.handleDrop(e, true)}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: 8
            }}
        >
            <Typography variant='h5' style={{
                marginBottom: 16,
            }}>GitHub Trophy</Typography>

            {
                (app.username) && <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start'
                }}>
                    <img src={`https://github-profile-trophy.vercel.app/?username=${app.username}&row=${width && width < 800 ? 4 : 1}&column=${width && width < 800 ? 2 : 6}&margin-w=15`} alt={app.username} />

                </div>
            }

            {
                (!app.username) && <Typography> Please fill the github username first </Typography>
            }


        </div>
    );
}

export default GitHubTrophy;